import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { LayoutDashboard, Package, FolderOpen, ShoppingCart, Users, Ticket, Image, Home, Settings as SettingsIcon, ArrowLeft, Truck, Search, Mail, MenuSquare, PanelBottom, Share2, Store } from "lucide-react";
import { useI18n } from "../../i18n";
import { useAuth } from "../../contexts/AuthContext";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, key: "overview", label_en: "Overview", label_nl: "Overzicht", end: true },
  { to: "/admin/orders", icon: ShoppingCart, key: "orders", label_en: "Orders", label_nl: "Bestellingen" },
  { to: "/admin/products", icon: Package, key: "products", label_en: "Products", label_nl: "Producten" },
  { to: "/admin/categories", icon: FolderOpen, key: "categories", label_en: "Categories", label_nl: "Categorieën" },
  { to: "/admin/customers", icon: Users, key: "customers", label_en: "Customers", label_nl: "Klanten" },
  { to: "/admin/sellers", icon: Store, key: "sellers", label_en: "Sellers", label_nl: "Verkopers" },
  { to: "/admin/discounts", icon: Ticket, key: "discounts", label_en: "Discounts", label_nl: "Kortingen" },
  { to: "/admin/media", icon: Image, key: "media", label_en: "Media", label_nl: "Media" },
  { to: "/admin/homepage", icon: Home, key: "homepage", label_en: "Homepage", label_nl: "Homepage" },
  { to: "/admin/navigation", icon: MenuSquare, key: "navigation", label_en: "Navigation", label_nl: "Navigatie" },
  { to: "/admin/footer", icon: PanelBottom, key: "footer", label_en: "Footer", label_nl: "Footer" },
  { to: "/admin/social", icon: Share2, key: "social", label_en: "Social & WhatsApp", label_nl: "Social & WhatsApp" },
  { to: "/admin/shipping", icon: Truck, key: "shipping", label_en: "Shipping", label_nl: "Verzending" },
  { to: "/admin/emails", icon: Mail, key: "emails", label_en: "Emails", label_nl: "Emails" },
  { to: "/admin/seo", icon: Search, key: "seo", label_en: "SEO", label_nl: "SEO" },
  { to: "/admin/settings", icon: SettingsIcon, key: "settings", label_en: "Settings", label_nl: "Instellingen" },
];

const AdminLayout = () => {
  const { lang } = useI18n();
  const { user } = useAuth();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-bone" data-testid="admin-layout">
      <div className="grid md:grid-cols-[260px_1fr]">
        {/* Sidebar */}
        <aside className="border-r border-black/10 bg-white md:min-h-screen sticky top-0 md:top-[64px] z-20">
          <div className="p-6 border-b border-black/5">
            <div className="font-label text-terracotta">Admin</div>
            <div className="font-display text-2xl mt-1">SnapShop</div>
            <div className="text-xs text-ink-muted mt-1 truncate">{user?.email}</div>
          </div>
          <nav className="p-3 space-y-0.5" data-testid="admin-sidebar">
            {NAV.map((n) => (
              <NavLink
                key={n.key}
                to={n.to}
                end={n.end}
                data-testid={`admin-nav-${n.key}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-ink text-white" : "hover:bg-secondary-warm text-ink"}`
                }
              >
                <n.icon className="w-4 h-4 shrink-0" />
                <span>{lang === "nl" ? n.label_nl : n.label_en}</span>
              </NavLink>
            ))}
          </nav>
          <div className="p-4 mt-4 border-t border-black/5">
            <NavLink to="/" className="text-xs font-label text-ink-muted hover:text-ink flex items-center gap-1.5">
              <ArrowLeft className="w-3.5 h-3.5" /> {lang === "nl" ? "Terug naar winkel" : "Back to store"}
            </NavLink>
          </div>
        </aside>

        {/* Content */}
        <main className="p-6 md:p-10 min-w-0" key={location.pathname}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
